package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.*

class AbsenceRepository(private val httpClient: HttpClient) {
    suspend fun getAbsences(workplaceId: Long): Result<List<AbsenceRequestDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/absence").body()
    }

    suspend fun createAbsence(workplaceId: Long, req: CreateAbsenceRequest): Result<Long> = runCatching {
        httpClient.post("workplaces/$workplaceId/absence") { setBody(req) }.body<Map<String, Long>>()["id"]!!
    }

    suspend fun reviewAbsence(absenceId: Long, req: ReviewAbsenceRequest): Result<Unit> = runCatching {
        httpClient.put("absence/$absenceId/review") { setBody(req) }
    }

    suspend fun updateAbsence(absenceId: Long, req: UpdateAbsenceRequest): Result<Unit> = runCatching {
        httpClient.put("absence/$absenceId") { setBody(req) }
    }

    suspend fun deleteAbsence(absenceId: Long): Result<Unit> = runCatching {
        httpClient.delete("absence/$absenceId")
    }
}
